import { render } from "./GemsSection.vue?vue&type=template&id=6aefb3c2&scoped=true"
const script = {}

import "./GemsSection.vue?vue&type=style&index=0&id=6aefb3c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aefb3c2"]])

export default __exports__